import { ArrowRightIcon, CreditCardIcon } from '@heroicons/react/24/outline'
import type { IUser } from '../../../../Model/index.js'
import { LicenseTier, userLicense } from '../../../../Model/index.js'
import { Link } from 'react-router-dom'
import { DASHBOARD_WIDGET_CLASS, planLabel, subscriptionState } from './dashboardUtils.ts'

export const SubscriptionWidget = ({ user }: { user: IUser }) => {
  const currentSubscription = subscriptionState(user)

  return (
    <section className={`${DASHBOARD_WIDGET_CLASS} xl:col-span-4`}>
      <div className="mb-4 flex items-center gap-2">
        <CreditCardIcon className="h-5 w-5 text-slate-600" />
        <h2 className="text-lg font-semibold text-slate-900">Subscription</h2>
      </div>
      <div className="space-y-3 text-sm">
        <div className="flex items-center justify-between gap-3">
          <span className="text-slate-500">State</span>
          <span className={`badge ${currentSubscription.className}`}>{currentSubscription.label}</span>
        </div>
        <div className="flex items-center justify-between gap-3">
          <span className="text-slate-500">Plan</span>
          <span className="font-medium text-slate-900">{planLabel(user.org.chargebeePlanId)}</span>
        </div>
        <div className="flex items-start justify-between gap-3">
          <span className="text-slate-500">Licenses</span>
          <span className="text-right font-medium text-slate-900">{userLicense(user)?.tier ?? LicenseTier.BASE}</span>
        </div>
      </div>
      <div className="mt-4">
        <Link to="/billing" className="inline-flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-slate-900">
          Open billing
          <ArrowRightIcon className="h-4 w-4" />
        </Link>
      </div>
    </section>
  )
}
